export const TOAST_STRING = {
  error: '오류가 발생했습니다. 다시 시도해 주세요.',
  saveHandwrittenNote: '필기를 저장완료 했습니다.',
  saveHandwrittenNoteFailed: '필기를 저장하지 못했습니다.',
  networkOffline: '인터넷 연결을 확인해주세요.',
}
